import script from "./HomeTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTitle.vue?vue&type=script&setup=true&lang=js"

import "./HomeTitle.vue?vue&type=style&index=0&id=e9de0804&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9de0804"]])

export default __exports__